var map = {
	"./esp-e-paper-frame.jpg": 3387,
	"./github-mark-white.png": 5249,
	"./github-mark.png": 1189,
	"./led-matrix-station.jpg": 3290,
	"./map-viewer.jpg": 1259,
	"./one-d-pong.jpg": 8248,
	"./project-background.jpg": 8078,
	"./stiftung-haus-pius.jpg": 6630,
	"./top-background.jpg": 2184
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9449;